<div class="vh-100">
<div *ngIf="this._displaySpinner" class="{{ this._style }}-spinner-loaderContainer">
  <mat-spinner class="spinner"></mat-spinner>
</div>
<router-outlet></router-outlet>
</div>
